import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import CardTitle from "@saleor/components/CardTitle";
import { Hr } from "@saleor/components/Hr";
import Skeleton from "@saleor/components/Skeleton";
import { maybe } from "@saleor/misc";
import { RemittanceStatusEnum } from "@saleor/types/globalTypes";
import { currencyFormat } from "@saleor/utils/formatters/currencyFormat";
import React from "react";
import { FormattedMessage } from "react-intl";

import RemittanceRunnerAgingBadge from "../RemittanceRunnerAgingBadge/RemittanceRunnerAgingBadge";
import RemittanceRunnerRemittanceStatus from "../RemittanceRunnerRemittanceStatus";

const useStyles = makeStyles(
  theme => ({
    copyBtn: {
      padding: "0px 0px 0px 5px"
    },
    headerHolder: {
      display: "inline-flex"
    },
    root: {
      ...theme.typography.body1,
      lineHeight: 1.9,
      width: "100%"
    },
    statusHolder: {
      // display: "flex",
      paddingLeft: "800px"
    },
    statusWrapper: {
      borderRadius: "25px",
      display: "inline",
      margin: "2px",
      marginLeft: "10px",
      paddingBottom: "5px",
      paddingTop: "5px",
      position: "relative",
      whiteSpace: "nowrap"
    },
    subSection: {
      display: "flex",
      flexDirection: "column",
      marginTop: "9px"
    },
    subSectionTitle: {
      flex: 1,
      fontWeight: 500,
      lineHeight: 1,
      marginTop: "0px"
    },
    textBold: {
      fontSize: "14px",
      fontWeight: 800,
      whiteSpace: "nowrap"
    },
    textRight: {
      fontSize: "14px",
      textAlign: "right",
      whiteSpace: "nowrap"
    }
  }),
  { name: "RemittanceRunnerRemittanceInfo" }
);

export interface RemittanceRunnerRemittanceInfoProps {
  dateRemitted: string;
  remittanceBranch: string;
  agingTime: number;
  remittanceAmount: number;
  status: RemittanceStatusEnum;
}

const RemittanceRunnerRemittanceInfo: React.FC<RemittanceRunnerRemittanceInfoProps> = props => {
  const {
    dateRemitted,
    remittanceBranch,
    agingTime,
    remittanceAmount,
    status
  } = props;
  const classes = useStyles(props);

  return (
    <Card>
      <CardTitle
        title="Remittance Info"
        toolbar={<RemittanceRunnerRemittanceStatus status={status} />}
      />
      <CardContent>
        <table className={classes.root}>
          <tbody>
            {/* Date Remitted */}
            <tr>
              <td className={classes.textBold}>
                <FormattedMessage
                  defaultMessage="Date Remitted"
                  description="Date Remitted"
                />
              </td>
              <td className={classes.textRight}>{dateRemitted}</td>
            </tr>

            {/* Remittance Branch */}
            <tr>
              <td className={classes.textBold}>
                <FormattedMessage
                  defaultMessage="Remittance Branch"
                  description="Remittance Branch"
                />
              </td>
              <td className={classes.textRight}>{remittanceBranch}</td>
            </tr>

            {/* Aging Time */}
            <tr>
              <td className={classes.textBold}>
                <FormattedMessage
                  defaultMessage="Aging Time"
                  description="Aging Time"
                />
              </td>
              <td className={classes.textRight}>
                {maybe(() => agingTime) ? (
                  <RemittanceRunnerAgingBadge
                    labelOnly={true}
                    aging={agingTime}
                    status={status}
                  />
                ) : (
                  <Skeleton />
                )}
              </td>
            </tr>

            {/* Remittance Amount */}
            <tr>
              <td className={classes.textBold}>
                <FormattedMessage
                  defaultMessage="Remittance Amount"
                  description="Remittance Amount"
                />
              </td>
              <td className={`${classes.textRight} ${classes.textBold}`}>
                {currencyFormat(remittanceAmount)}
              </td>
            </tr>
          </tbody>
        </table>
      </CardContent>
      <Hr />
    </Card>
  );
};
RemittanceRunnerRemittanceInfo.displayName = "RemittanceRunnerRemittanceInfo";
export default RemittanceRunnerRemittanceInfo;
